module.exports = __webpack_public_path__ + "14078943091f7f5814014ca4835d859a.svg";